import React, { useEffect, useState, Fragment } from "react";
import axios from "axios";

const Order = () => {

    const [order, setOrder] = useState(null);
  const [customer, setCustomer] = useState(null);
  const [product, setProduct] = useState(null);

  useEffect(() => {
    // Fetch Order Data
    const fetchOrderDetails = async () => {
      try {
        const response = await axios.get("http://localhost:8080/api/v3/order?orderNumber=4269");
        const orderData = response.data.object.content[0];
        setOrder(orderData);

        // Extract IDs
        const customerId = orderData.customerId;
        const productId = orderData.orderItem.productId;

        // Fetch Customer Details
        fetchCustomerDetails(customerId);

        // Fetch Product Details
        fetchProductDetails(productId);
      } catch (error) {
        console.error("Error fetching order details:", error);
      }
    };

    const fetchCustomerDetails = async (customerId) => {
      try {
        const customerResponse = await axios.get(`http://localhost:8080/api/v3/customer/${customerId}`);
        setCustomer(customerResponse.data);
      } catch (error) {
        console.error("Error fetching customer details:", error);
      }
    };

    const fetchProductDetails = async (productId) => {
      try {
        const productResponse = await axios.get(`http://localhost:8080/api/v3/product/${productId}`);
        setProduct(productResponse.data);
      } catch (error) {
        console.error("Error fetching product details:", error);
      }
    };

    fetchOrderDetails();
  }, []);


  return (
    <section className="order py-80">
      {/* Search Form */}
      <div className="search-form__wrapper position-relative d-flex align-items-center mb-4">
        <input
          type="text"
          className="search-form__input common-input py-13 ps-16 pe-18 rounded-pill"
          placeholder="Order Id#"
        />
        <button 
          type="button"
          className="w-80 h-32 flex-center ms-20 rounded shadow text-black border border-success"
        >
          Enter
        </button>
      </div>
      
 <div className="container" style={{marginTop:'5%'}}>
  <div className="row d-flex justify-content-center">
    
    <div className="col d-flex justify-content-center align-items-center flex-column" style={{ position: 'relative' }}>
      <div className="circle" style={{ width: '80px', height: '80px', border: '2px solid #007bff', borderRadius: '50%', display: 'flex', justifyContent: 'center', alignItems: 'center', fontSize: '2rem' }}>
        <i className="bi bi-clock fs-1"></i>
      </div>
      <div className="line" style={{ position: 'absolute', right: '-40px', top: '50%', width: '80px', height: '5px', backgroundColor: '#007bff', transform: 'translateY(-50%)' }}></div>
      <div className="status-name text-center mt-2">Pending</div>
    </div>

    
    <div className="col d-flex justify-content-center align-items-center flex-column" style={{ position: 'relative' }}>
      <div className="circle" style={{ width: '80px', height: '80px', border: '2px solid #007bff', borderRadius: '50%', display: 'flex', justifyContent: 'center', alignItems: 'center', fontSize: '2rem' }}>
        <i className="bi bi-gear fs-1"></i>
      </div>
      <div className="line" style={{ position: 'absolute', right: '-40px', top: '50%', width: '80px', height: '5px', backgroundColor: '#007bff', transform: 'translateY(-50%)' }}></div>
      <div className="status-name text-center mt-2">Processing</div>
    </div> 


    <div className="col d-flex justify-content-center align-items-center flex-column" style={{ position: 'relative' }}>
      <div className="circle" style={{ width: '80px', height: '80px', border: '2px solid #007bff', borderRadius: '50%', display: 'flex', justifyContent: 'center', alignItems: 'center', fontSize: '2rem' }}>
        <i className="bi bi-box fs-1"></i>
      </div>
      <div className="line" style={{ position: 'absolute', right: '-40px', top: '50%', width: '80px', height: '5px', backgroundColor: '#007bff', transform: 'translateY(-50%)' }}></div>
      <div className="status-name text-center mt-2">Product Pending</div>
    </div>

    {/* <!-- To Ship Status --> */}
    <div className="col d-flex justify-content-center align-items-center flex-column" style={{ position: 'relative' }}>
      <div className="circle" style={{ width: '80px', height: '80px', border: '2px solid #007bff', borderRadius: '50%', display: 'flex', justifyContent: 'center', alignItems: 'center', fontSize: '2rem' }}>
        <i className="bi bi-truck fs-1"></i>
      </div>
      <div className="line" style={{ position: 'absolute', right: '-40px', top: '50%', width: '80px', height: '5px', backgroundColor: '#007bff', transform: 'translateY(-50%)' }}></div>
      <div className="status-name text-center mt-2">To Ship</div>
    </div>

    {/* <!-- Shipped Status --> */}
    <div className="col d-flex justify-content-center align-items-center flex-column" style={{ position: 'relative' }}>
      <div className="circle" style={{ width: '80px', height: '80px', border: '2px solid #007bff', borderRadius: '50%', display: 'flex', justifyContent: 'center', alignItems: 'center', fontSize: '2rem' }}>
        <i className="bi bi-rocket fs-1"></i>
      </div>
      <div className="line" style={{ position: 'absolute', right: '-40px', top: '50%', width: '80px', height: '5px', backgroundColor: '#007bff', transform: 'translateY(-50%)' }}></div>
      <div className="status-name text-center mt-2">Shipped</div>
    </div>

    {/* <!-- Completed Status --> */}
    <div className="col d-flex justify-content-center align-items-center flex-column">
      <div className="circle" style={{ width: '80px', height: '80px', border: '2px solid #007bff', borderRadius: '50%', display: 'flex', justifyContent: 'center', alignItems: 'center', fontSize: '2rem' }}>
        <i className="bi bi-check-circle fs-1"></i>
      </div>
      <div className="status-name text-center mt-2">Completed</div>
    </div>
  </div>
</div>


    {/* //////////////////////////////////////////////////////// */}

    {/* <div className="container"style={{marginTop:'5%'}}>
  <h3>Order #38622 Details</h3>

  <div className="general-info mt-4">
    <h5>General</h5>
    <p><strong>Date created:</strong> 2024-12-11 @ 02:58</p>
    <p><strong>Status:</strong> To Ship</p>
    <p><strong>Customer:</strong> Chathurika Nadeeshani Katugampola</p>
  </div>

  <div className="billing-info mt-4">
    <h5>Billing</h5>
    <p><strong>Address:</strong> 08, 16/3a/12, Oval View Residencies, 265, Pelangasthuduwa Road, Pelangaswatta, Borella, Colombo</p>
    <p><strong>City:</strong> Colombo</p>
    <p><strong>Postal Code:</strong> 11300</p>
    <p><strong>Email address:</strong> sendani.k2005@gmail.com</p>
    <p><strong>Phone:</strong> 0771869188</p>
  </div>
</div> */}
<div className="container" style={{ marginTop: '5%' }}>
  <h3>Order #38622 Details</h3>

  <div className="row mt-4">
    
    <div className="col-md-6">
      <div className="shipping-info">
        <h5>Shipping</h5>
        <p><strong>Address:</strong> 08, 16/3a/12, Oval View Residencies, 265, Pelangasthuduwa Road, Pelangaswatta, Borella, Colombo</p>
        <p><strong>City:</strong> Colombo</p>
        <p><strong>Postal Code:</strong> 11300</p>
        <p><strong>Email address:</strong> sendani.k2005@gmail.com</p>
        <p><strong>Phone:</strong> 0771869188</p>
      </div>
    </div>

    
    <div className="col-md-6">
      <div className="billing-info">
        <h5>Billing</h5>
        <p><strong>Address:</strong> 08, 16/3a/12, Oval View Residencies, 265, Pelangasthuduwa Road, Pelangaswatta, Borella, Colombo</p>
        <p><strong>City:</strong> Colombo</p>
        <p><strong>Postal Code:</strong> 11300</p>
        <p><strong>Email address:</strong> sendani.k2005@gmail.com</p>
        <p><strong>Phone:</strong> 0771869188</p>
      </div>
    </div>
  </div>

  
  <div className="general-info mt-4">
    <h5>General</h5>
    <p><strong>Date created:</strong> 2024-12-11 @ 02:58</p>
    <p><strong>Status:</strong> To Ship</p>
    <p><strong>Customer:</strong> Chathurika Nadeeshani Katugampola</p>
  </div>
</div>

<div className="order-items mt-4">
    <h5>Order Items</h5>
    <table className="table table-bordered mt-3">
      <thead>
        <tr>
          <th>Product Image</th>
          <th>Product Name</th>
          <th>Quantity</th>
          <th>Price</th>
          <th>Total</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td><img src="https://via.placeholder.com/80" alt="Product" style={{ width: '80px', height: '80px', objectFit: 'cover' }} /></td>
          <td>Product Name 1</td>
          <td>2</td>
          <td>$20.00</td>
          <td>$40.00</td>
        </tr>
      </tbody>
    </table>
  </div>

  {/* Order Summary */}
  <div className="order-summary mt-4">
    <h5>Order Summary</h5>
    <div className="d-flex justify-content-between">
      <p><strong>Order Total:</strong></p>
      <p><strong>$55.00</strong></p>
    </div>
    <div className="d-flex justify-content-between">
      <p><strong>Shipping Total:</strong></p>
      <p><strong>$5.00</strong></p>
    </div>
    <div className="d-flex justify-content-between">
      <p><strong>Grand Total:</strong></p>
      <p><strong>$60.00</strong></p>
    </div>
  </div>



    </section>
  );
};

export default Order;
